/**
 * Thrown by BaseApiService when the API returns success: false with an error body.
 * `error_id` is always set by the server (see backend `apiError.ts`); the client must not mint UUIDs.
 */
export class ApiRequestError extends Error {
  readonly error_id?: string;
  readonly code?: string;
  readonly http_status?: number;

  constructor(message: string, opts?: { error_id?: string; code?: string; http_status?: number }) {
    super(message);
    this.name = 'ApiRequestError';
    this.error_id = opts?.error_id;
    this.code = opts?.code;
    this.http_status = opts?.http_status;
  }
}

/**
 * User-visible error string. Appends the server `error_id` when present so support can
 * correlate with logs / FullStory; does not generate IDs (that stays centralized on the API).
 */
export function formatApiErrorForUser(err: unknown): string {
  if (err instanceof ApiRequestError) {
    const ref = err.error_id ? ` Reference: ${err.error_id}` : '';
    return `${err.message}${ref}`;
  }
  if (err instanceof Error) {
    return err.message;
  }
  return 'An unexpected error occurred';
}
